module.exports = __webpack_public_path__ + "static/img/coverLeft.0e6f7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coverLeft.png
// module id = Mtzl
// module chunks = 3